import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cuántos antidepresivos debo probar antes de considerar SAINT®?",
    answer:
      "No hay un número fijo. SAINT® está indicada para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. El equipo clínico evalúa el historial en una consulta para determinar si SAINT® es adecuada.",
  },
];

export const esHowManyAntidepressants = makeEsArticle({
  slug: "how-many-antidepressants-should-i-try",
  title: "¿Cuántos antidepresivos debo probar?",
  description:
    "No hay un número fijo de antidepresivos que deba probar antes de considerar SAINT®. La decisión se evalúa en una consulta con el equipo clínico.",
  h1: "¿Cuántos antidepresivos debo probar?",
  breadcrumbLabel: "Cuántos antidepresivos probar",
  shortAnswer:
    "No hay un número fijo de antidepresivos que deba probar antes de considerar otras opciones. SAINT® está indicada para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. El equipo clínico evalúa el historial de tratamientos, los síntomas y la respuesta previa en una consulta para determinar si SAINT® es adecuada. No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
  keyTakeaways: [
    "No hay un número fijo de antidepresivos que deba probar.",
    "SAINT® está indicada cuando los antidepresivos no han mejorado lo suficiente.",
    "El equipo clínico evalúa el historial en una consulta.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
    "La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  ],
  sections: [
    {
      heading: "Cómo se decide",
      paragraphs: [
        "La decisión de considerar SAINT® no depende de un número concreto de intentos con antidepresivos. Depende de si los síntomas han mejorado lo suficiente con la medicación y del historial completo de cada persona.",
        "SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022) para el trastorno depresivo mayor en adultos que no han logrado una mejoría satisfactoria con antidepresivos en el episodio actual.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "U.S. Food and Drug Administration. 510(k) Premarket Notification — Magnus Neuromodulation System with SAINT Technology (K220177, September 2022).",
      url: "https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpmn/pmn.cfm",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
